export enum RequestChannelType {
  NotSpecified = 0,
  WebPortal = 1,
  CustomerAPI = 2,
  BulkUploader = 3,
  MobileApp = 4,
  JobAlert = 5,
  ECommerce = 6,
  VMEInteractiveSchedule = 7,
  SupplierInteractiveSchedule = 8,
  RecommendedRoute = 9,
  WidgetAPI = 10,
  RecommendedRouteMobile = 11,
}
